/* Official Kerala State Lottery drawn each weekday at 3 PM (Mon → Sun) */
const WEEKLY = [["Samrudhi", "SM"], ["Bhagyathara", "BT"], ["Sthree Sakthi", "SS"], ["Dhanalekshmi", "DL"], ["Karunya Plus", "KN"], ["Suvarna Keralam", "SK"], ["Karunya", "KR"]];

export const keralaOfficial = (ymd) => {
  if (!ymd) return null;
  // Calendar-date maths in UTC so the weekday never depends on the viewer's browser timezone
  const d = new Date(`${ymd}T00:00:00Z`);
  const [name, code] = WEEKLY[d.getUTCDay()];
  return { name, code, label: `${name} (${code})`, weekday: d.toLocaleDateString("en-IN", { weekday: "short", timeZone: "UTC" }), dateLabel: d.toLocaleDateString("en-IN", { weekday: "short", day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" }) };
};

export const isOfficialKerala = (g) => !!g && g.category === "Kerala" && g.mode !== "interval" && !g.auto_result && !g.live_reveal;
